import * as bootstrap from "bootstrap";
import Alpine from "alpinejs";
import observeStickyElement from "./stickyStuck";
import onReady from "./onReady";
import AOS from "aos";
import "fslightbox";

window.Alpine = Alpine;
window.bootstrap = bootstrap;

Alpine.start();

const componentModules = import.meta.glob(
	"../../site/templates/components/**/*.js",
);

const componentModuleByName = Object.entries(componentModules).reduce(
	(index, [modulePath, loader]) => {
		const fileName = modulePath.split("/").pop();
		if (!fileName || !fileName.endsWith(".js")) return index;

		const componentName = fileName.replace(/\.js$/, "");
		index[componentName] = loader;
		return index;
	},
	{},
);

function loadComponentScripts() {
	const componentNames = new Set(
		Array.from(document.querySelectorAll("[data-component]"))
			.map((element) => element.getAttribute("data-component"))
			.filter(Boolean),
	);

	componentNames.forEach((componentName) => {
		const loader = componentModuleByName[componentName];
		if (loader) loader();
	});
}

function setupCheckoutVisibility() {
	const checkout = document.querySelector(".navbar__checkout");
	const cartCount = document.querySelector("[rc-cart-count]");
	if (!checkout || !cartCount) return;

	const update = () => {
		const count = parseInt((cartCount.textContent || "0").trim(), 10) || 0;
		checkout.classList.toggle("is-visible", count > 0);
	};

	update();

	const observer = new MutationObserver(update);
	observer.observe(cartCount, {
		childList: true,
		subtree: true,
		characterData: true,
	});
}

onReady(function () {
	AOS.init({
		easing: "ease-in-out",
		offset: 50,
	});

	observeStickyElement();
	loadComponentScripts();
	setupCheckoutVisibility();
});
